import axios from 'axios'

export default() => {
  return axios.create({
    baseURL: 'https://sandisplay.allsan.fr'
    //baseURL: 'http://10.0.0.1:8081'
  })
}
